import Box from '@mui/material/Box';

export default function Selfy(props) {
    return (
        <Box
            component="img"
            sx={{
                height: 722,
                width: 579,
                maxHeight: { xs: 180, md: 360 },
                maxWidth: { xs: 145, md: 290 },
                borderRadius: '10%'
            }}
            alt="The house from the offer."
            src={props.imgSrc}
        />
    )
}